<section class="inchat-window" aria-label="Chat de soporte general">
	<header class="inchat-window__header">
		<div class="inchat-window__header-left">
			<button type="button" aria-label="Volver" (click)="back.emit()">
				<img
					appConcatenateSrc="09e16e8d-9781-4f7b-a840-fa252e51ab52-flecha&volver.svg"
					alt="Volver"
					class="inchat-icon inchat-icon--back"
				/>
			</button>
			<strong>Soporte general</strong>
		</div>
		<button type="button" aria-label="Cerrar chat" (click)="closed.emit()">
			<img
				appConcatenateSrc="7fe389a4-523f-44f6-b35f-ff6f592f7c9c-x&cerrar.svg"
				alt="Cerrar"
				class="inchat-icon inchat-icon--close"
			/>
		</button>
	</header>
	<ng-container>
		<main class="inchat-window__messages" #scrollContainer>
			<div
				*ngIf="connectionState === 'reconnecting'"
				class="inchat-system-message inchat-system-message--reconnecting"
			>
				Intentando reconectar...
			</div>
			<div *ngFor="let item of messages; let i = index">
				<!-- Separador de fecha -->
				<div
					*ngIf="shouldShowDateSeparator(i) && item.dateObj"
					class="inchat-window__date-separator-container"
				>
					<span class="inchat-window__date-separator">
						{{ getDateSeparatorText(item.dateObj) }}
					</span>
				</div>
				<div class="message" [class.message--user]="item.sender === 'user'">
					<img
						*ngIf="item.sender === 'bot'"
						appConcatenateSrc="206aff6e-5612-417f-8dfb-03c951b96468-respuestabot.svg"
						class="message__bot-avatar"
						alt="Bot"
					/>
					<div class="message__content">
						<div class="message__row" *ngIf="item.text || item.attachment">
							<div class="message__bubble">
								<div *ngIf="item.contextId && (item.contextText || item.contextName)" class="message__context-box">
									<span class="message__context-name">{{ item.contextName || 'Mensaje' }}</span>
									<span class="message__context-text" [innerHTML]="formatText(item.contextText || 'Mensaje citado')"></span>
								</div>
								
								<div *ngIf="item.attachment" class="message__attachment">
									<ng-container *ngIf="item.attachment.type === 'image'">
										<img
											[src]="item.attachment.url"
											[alt]="item.attachment.name"
											class="message__attachment-img"
										/>
									
										<button type="button" (click)="downloadAttachment(item.attachment)" class="message__download-btn">
											⬇ Descargar archivo
										</button>
									</ng-container>
									<ng-container *ngIf="item.attachment.type === 'audio'">
										<audio
											[src]="item.attachment.url"
											controls
											class="message__attachment-audio"
										></audio>
									</ng-container>
									<ng-container *ngIf="item.attachment.type === 'document'">
										<div class="message__attachment-doc">
											<img
												appConcatenateSrc="ff62564c-9195-4e32-955a-d047528bd24d-documento.svg"
												alt="Documento"
												class="inchat-icon inchat-icon--doc"
											/>
											<span class="message__attachment-name">{{
												item.attachment.name
											}}</span>
										</div>
										<button type="button" (click)="downloadAttachment(item.attachment)" class="message__download-btn">
											⬇ Descargar archivo
										</button>
									</ng-container>
								</div>
								<span
									*ngIf="item.text"
									class="message__text"
									[innerHTML]="formatText(item.text)"
								></span>
								<small class="message__time">
									{{ item.time }}
									<span class="message__status" *ngIf="item.sender === 'user'">
										<ng-container [ngSwitch]="item.status">
											<svg
												*ngSwitchCase="'sending'"
												viewBox="0 0 24 24"
												class="inchat-icon inchat-icon--status message__status-icon"
											>
												<circle class="inchat-icon__circle"></circle>
												<polyline
													points="12 6 12 12 16 14"
													class="inchat-icon__polyline"
												></polyline>
											</svg>
											<svg
												*ngSwitchCase="'sent'"
												viewBox="0 0 24 24"
												class="inchat-icon inchat-icon--status message__status-icon"
											>
												<polyline
													points="20 6 9 17 4 12"
													class="inchat-icon__polyline"
												></polyline>
											</svg>
											<span *ngSwitchCase="'read'" class="message__status-read">✓✓</span>
											<span *ngSwitchCase="'error'" class="message__status-error">!</span>
											<span *ngSwitchDefault>✓✓</span>
											<!-- fallback -->
										</ng-container>
									</span>
									<span *ngIf="item.sender === 'bot'">✓✓</span>
								</small>
							</div>
							<button
								type="button"
								*ngIf="item.id"
								(click)="replyToMessage(item)"
								title="Responder"
								class="message__reply-btn"
							>
								<svg viewBox="0 0 24 24" class="inchat-icon inchat-icon--reply">
									<polyline points="9 17 4 12 9 7" class="inchat-icon__polyline"></polyline>
									<path d="M20 18v-2a4 4 0 0 0-4-4H4" class="inchat-icon__path"></path>
								</svg>
							</button>
						</div>
						<div class="message__actions" *ngIf="item.actions && item.actions.length > 0">
							<button
								*ngFor="let action of item.actions"
								[ngClass]="'inchat-action--' + action.style"
								(click)="handleAction(action, item.id)"
							>
								{{ action.title }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</main>
		<div class="inchat-window__input-container">
			<!-- Vista previa de archivo adjunto (Estilo WhatsApp) -->
			<div class="attachment-preview" *ngIf="pendingAttachment">
				<div class="attachment-preview__content">
					<ng-container *ngIf="pendingAttachment.type === 'image'">
						<img [src]="pendingAttachment.url" [alt]="pendingAttachment.name" />
					</ng-container>
					<ng-container
						*ngIf="pendingAttachment.type === 'document' || pendingAttachment.type === 'audio'"
					>
						<div class="attachment-preview__doc-icon">
							<img
								*ngIf="pendingAttachment.type === 'document'"
								appConcatenateSrc="ff62564c-9195-4e32-955a-d047528bd24d-documento.svg"
								alt="Documento"
								class="inchat-icon inchat-icon--doc"
							/>
							<img
								*ngIf="pendingAttachment.type === 'audio'"
								appConcatenateSrc="1b30533e-3eec-4123-894b-e57ae9bb21f0-microfono.svg"
								alt="Audio"
								class="inchat-icon inchat-icon--audio"
							/>
						</div>
						<span>{{ pendingAttachment.name }}</span>
					</ng-container>
				</div>
				<button
					type="button"
					class="attachment-preview__close"
					(click)="clearAttachment()"
					aria-label="Remover archivo"
				>
					<svg viewBox="0 0 24 24" class="inchat-icon inchat-icon--remove">
						<path d="m6 6 12 12M18 6 6 18" class="inchat-icon__path" />
					</svg>
				</button>
			</div>
			<form class="inchat-window__input" (ngSubmit)="sendMessage()">
				<input
					type="file"
					#fileInput
					(change)="onFileSelected($event)"
					accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
					class="inchat-window__file-input"
				/>
				<button type="button" aria-label="Adjuntar" (click)="fileInput.click()">
					<img
						appConcatenateSrc="a7837e22-357c-46b6-a057-1e8c486a9522-mas&adjuntar.svg"
						alt="Adjuntar"
						class="inchat-icon inchat-icon--attach"
					/>
				</button>
				<div class="attachment-preview attachment-preview--replying" *ngIf="replyingToMessage">
					<div class="attachment-preview__reply-text">
						<strong class="attachment-preview__reply-title"
							>Respondiendo a
							{{ replyingToMessage.sender === 'user' ? 'ti' : 'Soporte' }}</strong
						>
						{{ replyingToMessage.text || 'Archivo adjunto' }}
					</div>
					<button type="button" (click)="cancelReply()" class="attachment-preview__reply-cancel">
						<svg viewBox="0 0 24 24" class="inchat-icon inchat-icon--remove">
							<path d="m6 6 12 12M18 6 6 18" class="inchat-icon__path" />
						</svg>
					</button>
				</div>
				<textarea
					name="message"
					[(ngModel)]="message"
					placeholder="Escribe un mensaje"
					rows="1"
					(input)="adjustHeight($event)"
					(keydown)="onKeyDown($event)"
				></textarea>
				<button type="button" aria-label="Emoji" (click)="toggleEmojiPicker($event)">
					<img
						appConcatenateSrc="13b62a62-bcf1-4ec0-a453-8a9d37afd07f-emoji.svg"
						alt="Emoji"
						class="inchat-icon inchat-icon--emoji"
					/>
				</button>
				<button
					*ngIf="message.trim().length > 0 || pendingAttachment; else micBtn"
					type="submit"
					aria-label="Enviar mensaje"
				>
					<img
						appConcatenateSrc="dd3ca513-0a63-4cb3-b4ee-2116c6acf937-enviar.svg"
						alt="Enviar"
						class="inchat-icon inchat-icon--send"
					/>
				</button>
				<ng-template #micBtn>
					<button type="button" aria-label="Grabar audio" (click)="toggleRecording()">
						<img
							*ngIf="!isRecording"
							appConcatenateSrc="1b30533e-3eec-4123-894b-e57ae9bb21f0-microfono.svg"
							alt="Micrófono"
							class="inchat-icon inchat-icon--mic"
						/>
						<svg
							*ngIf="isRecording"
							viewBox="0 0 24 24"
							class="inchat-icon inchat-icon--recording"
						>
							<circle class="inchat-icon__circle" />
							<rect class="inchat-icon__rect" />
						</svg>
					</button>
				</ng-template>
			</form>
		</div>
		<div class="emoji-picker-container" *ngIf="showEmojiPicker">
			<emoji-mart (emojiClick)="addEmoji($event)" title="Elige un emoji" emoji="point_up" [showPreview]="false" [perLine]="8"></emoji-mart>
		</div>
		<footer (click)="goToFullChat()" class="inchat-window__footer">
			Abrir
			<img
				appConcatenateSrc="52dba03e-d69c-4cd0-9be6-53aaa4690516-logo&text.svg"
				alt="INChat Text"
				class="inchat-window__footer-logo"
			/>
		</footer>
	</ng-container>
</section>
